import { createRegistry } from "@/lib/home/registry";
import answer from "./answer";
import clock from "./clock";
import command from "./command";
import links from "./links";
import notes from "./notes";
import pinned from "./pinned";
import prompts from "./prompts";
import recent from "./recent";
import tabs from "./tabs";
import tasks from "./tasks";

/**
 * Every widget the board can show (ADMIN-257). The order here is the add tray's order. Only the
 * manifests load with the page; each component is fetched when a board first shows it.
 */
export const widgets = createRegistry([
  command,
  recent,
  pinned,
  notes,
  tasks,
  tabs,
  links,
  prompts,
  clock,
  answer,
]);
